import { lazy } from 'react';

export const AttributePageLazy = lazy(() =>
  // eslint-disable-next-line import/no-cycle
  import(/* webpackChunkName: "AttributesPage" */ './AttributesPage').then(
    ({ AttributesPage }) => ({ default: AttributesPage }),
  ),
);
